export enum CepManagedModelType {
  // Email
  EmailReceived = "email_received",
  EmailOpened = "email_opened",
  EmailClicked = "email_clicked",
  EmailUnsubscribed = "email_unsubscribed",
  EmailSubscribed = "email_subscribed",
  EmailBounced = "email_bounced",
  EmailMarkedSpam = "email_marked_spam",

  // SMS
  SmsReceived = "sms_received",
  SmsRead = "sms_read",
  SmsClicked = "sms_clicked",
  SmsUnsubscribed = "sms_unsubscribed",
  SmsSubscribed = "sms_subscribed",

  // WhatsApp
  WhatsappReceived = "whatsapp_received",
  WhatsappRead = "whatsapp_read",
  WhatsappClicked = "whatsapp_clicked",
  WhatsappUnsubscribed = "whatsapp_unsubscribed",
  WhatsappSubscribed = "whatsapp_subscribed",

  // Push
  PushReceived = "push_received",
  PushOpened = "push_opened",
  PushUnsubscribed = "push_unsubscribed",
  PushSubscribed = "push_subscribed",

  // Shared
  SubscriptionTopics = "subscription_topics",
  TimeZonePerProfile = "time_zone_per_profile",
  Signups = "signups",
}

// Signups is still in development, so it stays deletable while we test and iterate on it.
const REMOVABLE_MANAGED_MODEL_TYPES: ReadonlySet<string> = new Set([
  CepManagedModelType.Signups,
]);

export const isRemovableManagedModel = (type: string): boolean =>
  REMOVABLE_MANAGED_MODEL_TYPES.has(type);
